import { useRef, } from 'react';
import { CircleBusinessZoom } from '@/common/components/business/ExpandStore/CircleBusinessMap/ts-config';
import { v4 } from 'uuid'; // 用来生成不重复的key
import styles from './index.module.less';
import { ShopItem } from '@/common/components/business/ExpandStore/CircleBasicInfo/ts-config';
import ReactDOM from 'react-dom';
import { RelateChancePoint } from '../CircleBasicInfo/ts-config';
import { isDef } from '@lhb/func';
import { ProtectString } from '@/common/components/business/ExpandStore/ts-config';

export function useHoverMarker(map) {
  const hoverMarkerRef = useRef<any>(null);

  const createHoverMarker = (info:ShopItem) => {
    const uid:any = v4();
    if (hoverMarkerRef.current && hoverMarkerRef.current._opts.extData === info.id) return;
    if (hoverMarkerRef.current && hoverMarkerRef.current._opts.extData !== info.id)removeHoverMarker();
    const marker = new window.AMap.Marker({
      zooms: [CircleBusinessZoom.MinZomm, 20],
      anchor: 'top-center',
      position: new window.AMap.LngLat(+info.lng, +info.lat),
      extData: info.id,
      offset: [0, 1],
      content: `<div id=${uid}></div>`
    });
    map.add(marker); // 添加到地图
    hoverMarkerRef.current = marker;
    const Node = <div className={styles.hoverMarkerWrapper}>
      <span className={styles['address']}>{info.address}</span>
      <div className={styles['status']}>{info.statusName}</div>
    </div>;
    ReactDOM.render(Node, document.getElementById(uid));

  };

  const removeHoverMarker = () => {
    if (hoverMarkerRef.current) {
      map.remove(hoverMarkerRef.current);
      hoverMarkerRef.current = null;
    }

  };

  return {
    hoverMarker: hoverMarkerRef.current,
    createHoverMarker,
    removeHoverMarker
  };
}

export function useHoverChanceMarker(map) {
  const hoverMarkerRef = useRef<any>(null);

  const createHoverChanceMarker = (info:RelateChancePoint) => {
    const uid:any = v4();
    if (hoverMarkerRef.current && hoverMarkerRef.current._opts.extData === info.id) return;
    if (hoverMarkerRef.current && hoverMarkerRef.current._opts.extData !== info.id) removeHoverChanceMarker();
    const marker = new window.AMap.Marker({
      zooms: [CircleBusinessZoom.MinZomm, 20],
      anchor: 'top-center',
      position: new window.AMap.LngLat(+info.lng, +info.lat),
      extData: info.id,
      offset: [0, 1],
      content: `<div id=${uid}></div>`
    });
    map.add(marker); // 添加到地图
    hoverMarkerRef.current = marker;

    const isProtected = info.protectInfo?.protectRadius && info.protectInfo?.statusName === ProtectString.On;
    const Node = isProtected ? hoverChancePointWithProtect(info) : hoverChancePointWithoutProtect(info);
    ReactDOM.render(Node, document.getElementById(uid));
  };

  const hoverChancePointWithProtect = (info: RelateChancePoint) => {
    return <div className={styles.protectedChanceContent}>
      <div className={styles.name}>{info?.name}</div>
      <div className={styles.status}>
        <span className={styles.protect}>区域保护中</span>
      </div>
      {info?.statusName ? <div className={styles.card}>
        <span className={styles.label}>机会点状态</span>
        <span className={styles.content}>{info.statusName}</span>
      </div> : <></>}
      {info?.protectInfo.applyUserName ? <div className={styles.card}>
        <span className={styles.label}>保护申请人</span>
        <span className={styles.content}>{info.protectInfo.applyUserName}</span>
      </div> : <></>}
      {isDef(info.protectInfo?.daysToExpiration) ? <div className={styles.card}>
        <span className={styles.label}>保护有效期</span>
        <span className={styles.content}>剩余{info.protectInfo.daysToExpiration}</span>
      </div> : <></>}

      {info.protectInfo?.scopeProtection ? <div className={styles.card}>
        <span className={styles.label}>保护范围</span>
        <span className={styles.content}>{info.protectInfo.scopeProtection}</span>
      </div> : <></>}
    </div>;
  };

  const hoverChancePointWithoutProtect = (info:RelateChancePoint) => {
    return <div className={styles.chancePointContent}>
      <span className={styles.name}>{info.name}</span>
      <div className={styles.status}>{info.statusName}</div>
    </div>;
  };

  const removeHoverChanceMarker = () => {
    if (hoverMarkerRef.current) {
      map.remove(hoverMarkerRef.current);
      hoverMarkerRef.current = null;
    }

  };

  return {
    hoverMarker: hoverMarkerRef.current,
    createHoverChanceMarker,
    removeHoverChanceMarker
  };
}
